import React from 'react';

const MyAccount = () => {
  return (
    <div
      style={{
        padding: '20px'
      }}>
      <h1>My Account</h1>
      <p>Under construction ...</p>
    </div>
  );
};

export default MyAccount;
